module.exports = __webpack_public_path__ + "static/media/sura-clock.e1f83938.svg";